export const weebly = [
  {
    id: '1',
    meta: {
      cart_key: 'weebly:test-1.site',
      domain: 'test-1.site',
      email: 'test+3bc709a268bfe14daf9cd5b5da6f34a4@gmail.com',
      hp_addon_id: '5520791',
      lineitem_id: '100011651',
      migration_status: 'complete',
      php_upgraded: '1',
      service_id: 'basic',
      site_id: '201543905694412926',
      sys_desc: 'test-1.site',
      weebly_cloud_id: '141357382',
    },
    site_id: null,
    status: 'active',
    status_user: 'Active',
    subtype: '',
    type: 'weebly',
  },
  {
    id: '404',
    meta: {
      cart_key: 'weebly:test-2.site',
      domain: 'test-2.site',
      email: 'test+3bc709a268bfe14daf9cd5b5da6f34a4@gmail.com',
      hp_addon_id: '5520791',
      lineitem_id: '100011651',
      migration_status: 'complete',
      php_upgraded: '1',
      service_id: 'basic',
      site_id: '201543905694412926',
      sys_desc: 'test-2.site',
      weebly_cloud_id: '141357382',
    },
    site_id: null,
    status: 'active',
    status_user: 'Active',
    subtype: '',
    type: 'weebly',
  },
  {
    id: '512',
    meta: {
      cart_key: 'weebly:test-3.site',
      domain: 'test-3.site',
      email: 'test+3bc709a268bfe14daf9cd5b5da6f34a4@gmail.com',
      hp_addon_id: '5520791',
      lineitem_id: '100011651',
      migration_status: 'complete',
      php_upgraded: '1',
      service_id: 'basic',
      site_id: '201543905694412926',
      sys_desc: 'test-3.site',
      weebly_cloud_id: '141357382',
    },
    site_id: null,
    status: 'active',
    status_user: 'Active',
    subtype: '',
    type: 'weebly',
  },
  {
    id: '4',
    meta: {
      cart_key: 'weebly:test-4.site',
      domain: 'test-4.site',
      email: 'test+4bc709a268bfe14daf9cd5b5da6f34a4@gmail.com',
      hp_addon_id: '5520791',
      lineitem_id: '100011651',
      migration_status: 'complete',
      php_upgraded: '1',
      service_id: 'basic',
      site_id: '201543905694412926',
      sys_desc: 'test-4.site',
      weebly_cloud_id: '141357382',
    },
    site_id: null,
    status: 'deleted',
    status_user: 'Active',
    subtype: '',
    type: 'weebly',
  },
];

export const webzai = [
  {
    id: '10',
    meta: {
      cart_key: 'sitebuilder:a9fa2086-caf8-11ea-a5a3-e712a52199e3',
      domain: 'memepeda.com',
      email: 'pbmsjlmybluehostme-5974130@localhost.localdomain',
      ftp_path: 'public_html/memepeda',
      hosting_id: '1612336',
      hp_addon_id: '3698988',
      limit_banner_feature: '0',
      limit_ecommerce: '0',
      limit_favicon: '0',
      limit_file: '0',
      limit_history: '0',
      limit_mobile: '0',
      limit_new_sites: '0',
      limit_pages: '0',
      limit_posts: '0',
      limit_premium: '0',
      limit_publish: '0',
      limit_stats: '0',
      limit_storage: '0',
      limit_total_pages: '0',
      limit_video: '0',
      limitations:
        '{"ecommerce":{"limitation":{"isLimited":1}},"file":{"limitation":{"isLimited":0}},"mobile":{"limitation":{"isLimited":0}},"posts":{"limitation":{"isLimited":0}},"history":{"limitation":{"isLimited":0}},"embedded":{"limitation":{"isLimited":0}},"video":{"limitation":{"isLimited":0}},"totalPages":{"limitation":{"isLimited":0}},"favicon":{"limitation":{"isLimited":0}},"stats":{"limitation":{"isLimited":0}},"bannerFeature":{"iframeUrl":"http://www.memepeda.com","limitation":{"isLimited":0}},"newSites":{"limitation":{"isLimited":0}},"publish":{"limitation":{"isLimited":0}},"premium":{"limitation":{"isLimited":0}},"storage":{"limitation":{"isLimited":0}},"pages":{"limitation":{"isLimited":0}}}',
      lineitem_id: '89666115',
      name: 'Marco Daccarett',
      renewal_option: 'a1',
      safe_webzai_ftp_pass: '1',
      site_name: 'Bluehost Builder',
      sys_desc: 'a9fa2086-caf8-11ea-a5a3-e712a52199e3',
      template_id: '2226',
      webzai_account_id: '35206936',
      webzai_ftp_user: 'builder-7214da2379e5@dimeloenchino.com',
    },
    site_id: '4566981',
    status: 'active',
    status_user: 'Active',
    subtype: 'express',
    type: 'webzai',
  },
  // {
  //   id: '11',
  //   meta: {
  //     cart_key: 'sitebuilder:a9fa2086-caf8-11ea-a5a3-e712a52199e3',
  //     domain: 'test.com',
  //     email: 'pbmsjlmybluehostme-5974130@localhost.localdomain',
  //     ftp_path: 'public_html/test',
  //     hosting_id: '1612336',
  //     hp_addon_id: '3698988',
  //     limit_banner_feature: '0',
  //     limit_ecommerce: '0',
  //     limit_favicon: '0',
  //     limit_file: '0',
  //     limit_history: '0',
  //     limit_mobile: '0',
  //     limit_new_sites: '0',
  //     limit_pages: '0',
  //     limit_posts: '0',
  //     limit_premium: '0',
  //     limit_publish: '0',
  //     limit_stats: '0',
  //     limit_storage: '0',
  //     limit_total_pages: '0',
  //     limit_video: '0',
  //     limitations:
  //       '{"ecommerce":{"limitation":{"isLimited":1}},"file":{"limitation":{"isLimited":0}},"mobile":{"limitation":{"isLimited":0}},"posts":{"limitation":{"isLimited":0}},"history":{"limitation":{"isLimited":0}},"embedded":{"limitation":{"isLimited":0}},"video":{"limitation":{"isLimited":0}},"totalPages":{"limitation":{"isLimited":0}},"favicon":{"limitation":{"isLimited":0}},"stats":{"limitation":{"isLimited":0}},"bannerFeature":{"iframeUrl":"http://www.memepeda.com","limitation":{"isLimited":0}},"newSites":{"limitation":{"isLimited":0}},"publish":{"limitation":{"isLimited":0}},"premium":{"limitation":{"isLimited":0}},"storage":{"limitation":{"isLimited":0}},"pages":{"limitation":{"isLimited":0}}}',
  //     lineitem_id: '89666115',
  //     name: 'Marco Daccarett',
  //     renewal_option: 'a1',
  //     safe_webzai_ftp_pass: '1',
  //     site_name: 'Bluehost Builder',
  //     sys_desc: 'a9fa2086-caf8-11ea-a5a3-e712a52199e3',
  //     template_id: '2226',
  //     webzai_account_id: '35206936',
  //     webzai_ftp_user: 'builder-7214da2379e5@dimeloenchino.com',
  //   },
  //   site_id: '4566981',
  //   status: 'active',
  //   status_user: 'Active',
  //   subtype: 'express',
  //   type: 'webzai',
  // },
];

export const spamExperts = [
  {
    id: '123456',
    meta: {
      domain: 'se-domain-01.spam',
    },
    status: 'active',
    type: 'spamexperts',
    status_user: 'Active',
  },
  {
    id: '123457',
    meta: {
      domain: 'se-domain-02.spam',
    },
    status: 'active',
    type: 'spamexperts',
    status_user: 'Active',
  },
];

export const yoast = [
  {
    id: '200',
    type: 'yoast',
    subtype: '',
    meta: {
      _delete_date: '2022-04-25 09:45:01',
      auto_delete_days: '3',
      cart_key: 'cloudflarecdn:example.org',
      dcv_method: 'certificate',
      domain: 'yoast-active.org',
      hp_addon_id: '5565333',
      is_test: '1',
      lineitem_id: '88603316',
      renewal_option: 'a0',
      server_ip: '162.241.24.41',
      sys_desc: 'example.org',
    },
    status: 'active',
    status_user: 'Active',
  },
  {
    id: '201',
    type: 'yoast',
    subtype: '',
    meta: {
      _delete_date: '2022-04-25 09:45:01',
      auto_delete_days: '3',
      cart_key: 'cloudflarecdn:example.org',
      dcv_method: 'certificate',
      domain: 'yoast-inactive.org',
      hp_addon_id: '5565333',
      is_test: '1',
      lineitem_id: '88603316',
      renewal_option: 'a0',
      server_ip: '162.241.24.41',
      sys_desc: 'example.org',
    },
    status: 'inactive',
    status_user: 'Active',
  },
];

export const backup = [
  {
    back_reference: null,
    id: '2428271',
    meta: {
      automated_daily_backups: '1',
      backup_archives: '0',
      backup_download: '1',
      backup_retention: '7',
      can_upgrade: '1',
      change_notifications: '0',
      custom_scheduled_backups: '1',
      database_backup: '1',
      on_demand_backups: '1',
      one_click_site_restore: '1',
      selective_restore: '0',
    },
    site_id: null,
    status: 'active',
    subtype: 'premium',
    type: 'backup',
    status_user: 'Active',
  },
  {
    back_reference: null,
    id: '500',
    meta: {
      automated_daily_backups: '1',
      backup_archives: '0',
      backup_download: '1',
      backup_retention: '7',
      can_upgrade: '1',
      change_notifications: '0',
      custom_scheduled_backups: '1',
      database_backup: '1',
      on_demand_backups: '1',
      one_click_site_restore: '1',
      selective_restore: '0',
    },
    site_id: null,
    status: 'active',
    subtype: 'standard',
    type: 'backup',
    status_user: 'Active',
  },
  {
    back_reference: null,
    id: '404',
    meta: {
      automated_daily_backups: '1',
      backup_archives: '0',
      backup_download: '1',
      backup_retention: '7',
      can_upgrade: '1',
      change_notifications: '0',
      custom_scheduled_backups: '1',
      database_backup: '1',
      on_demand_backups: '1',
      one_click_site_restore: '1',
      selective_restore: '0',
    },
    site_id: null,
    status: 'active',
    subtype: 'standard',
    type: 'backup',
    status_user: 'Active',
  },
];

export const wpsolution = [
  {
    back_reference: 'WN.HP.625402706',
    id: '2156214',
    meta: {
      auto_delete_days: '3',
      is_test: '1',
      site_id: '2',
      solution_expiration_date: '2025-10-18 16:39:11',
      is_wp_expired: false,
    },
    site_id: null,
    status: 'active',
    subtype: 'commerce',
    type: 'wpsolution',
    status_user: 'Active',
  },

  {
    back_reference: 'WN.HP.625402716',
    id: '2156218',
    meta: {
      auto_delete_days: '3',
      is_test: '1',
      site_id: '1',
      solution_expiration_date: '2025-10-18 16:57:31',
      is_wp_expired: false,
    },
    site_id: null,
    status: 'active',
    subtype: 'creator',
    type: 'wpsolution',
    status_user: 'Active',
  },
];

const cloudflare = [
  {
    back_reference: null,
    id: '2116833',
    meta: {
      abandoned: '1',
      dcv_method: 'http',
      dcv_ownership: '1',
      dcv_ownership_www: '1',
      domain: 'example.com',
      manual_workflow: '0',
      original_ip: '50.87.245.245',
      server_ip: '50.87.245.245',
    },
    site_id: null,
    ssh_hostname: 'rock505.eigdev.com',
    status: 'active',
    subtype: '',
    type: 'cloudflare',
    status_user: 'Active',
  },
];

export const hostingAddons = (type: any) => {
  const addons = [
    ...weebly,
    ...webzai,
    ...spamExperts,
    ...yoast,
    ...wpsolution,
    ...backup,
    ...cloudflare,
  ];
  return type ? addons.filter((addon) => addon.type === type) : addons;
};
